import { render, staticRenderFns } from "./InputReviewPerilakuDetail.vue?vue&type=template&id=3e953f1b&scoped=true&lang=html&"
import script from "./InputReviewPerilakuDetail.vue?vue&type=script&lang=js&"
export * from "./InputReviewPerilakuDetail.vue?vue&type=script&lang=js&"
import style0 from "./InputReviewPerilakuDetail.vue?vue&type=style&index=0&id=3e953f1b&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e953f1b",
  null
  
)

export default component.exports